import { Criterios, GenericPlace } from '../../interfaces';
import axios from '../axiosServicesPoleposition';

async function GetPolepositionTypes() {
  const response = await axios.get('admin/pole-position/v1/tipos-polepositions-validos');
  return response;
}
async function GetPolepositionById(id: string) {
  const response = await axios.get(`admin/pole-position/v1/${id}`);
  return response;
}
async function SavePolepostion(
  name: string,
  fileName: string,
  descricaoBeneficio: string,
  imgBase64: string,
  criterions: Array<Criterios>,
  places: Array<GenericPlace>,
  vantagens: Array<{
    to: string;
    from: string;
    end: string;
  }>,
  tipoPolePosition: number,
) {
  await axios.post('admin/pole-position/v1', {
    nome: name,
    descricaoBeneficio,
    imagem: {
      nomeImagem: fileName,
      imagemBase64: imgBase64,
    },
    criterios: criterions.filter((item: Criterios) => item.check)
      .map((item: Criterios) => item.idCriterio),
    locais: places.filter((item) => item.check).map((item) => item.idLocal),
    vantagens,
    tipoPolePosition,
  });
}

async function SavePolepostionToAnticipation(
  name: string,
  fileName: string,
  descricaoBeneficio: string,
  imgBase64: string,
  criterions: Array<Criterios>,
  places: Array<GenericPlace>,
  tipoPolePosition: number,
  minutosAntecipacaoAgendamento: number,
  quantidadeCorretoresBeneficiados: number,
) {
  await axios.post('admin/pole-position/v1', {
    nome: name,
    descricaoBeneficio,
    imagem: {
      nomeImagem: fileName,
      imagemBase64: imgBase64,
    },
    criterios: criterions.filter((item: Criterios) => item.check)
      .map((item: Criterios) => item.idCriterio),
    locais: places.filter((item) => item.check).map((item) => item.idLocal),
    tipoPolePosition,
    minutosAntecipacaoAgendamento,
    quantidadeCorretoresBeneficiados,
  });
}
async function SavePolepostionBloqued(
  name: string,
  fileName: string,
  descricaoBeneficio: string,
  imgBase64: string,
  criterions: Array<Criterios>,
  places: Array<GenericPlace>,
  vantagens: Array<{
    to: string;
    from: string;
    end: string;
  }>,
  tipoPolePosition: number,
  quantidadeCorretoresBeneficiados: number,
) {
  await axios.post('admin/pole-position/v1', {
    nome: name,
    descricaoBeneficio,
    imagem: {
      nomeImagem: fileName,
      imagemBase64: imgBase64,
    },
    criterios: criterions.filter((item: Criterios) => item.check)
      .map((item: Criterios) => item.idCriterio),
    locais: places.filter((item) => item.check).map((item) => item.idLocal),
    vantagens,
    tipoPolePosition,
    quantidadeCorretoresBeneficiados,
  });
}

async function updatePolepostion(
  name: string,
  fileName: string,
  descricaoBeneficio: string,
  imgBase64: string,
  criterions: Array<Criterios>,
  places: Array<GenericPlace>,
  vantagens: Array<{
    to: string;
    from: string;
    end: string;
  }>,
  tipoPolePosition: number,
  id: string,
) {
  await axios.put(`admin/pole-position/v1/${id}`, {
    nome: name,
    descricaoBeneficio,
    imagem: fileName ? {
      nomeImagem: fileName,
      imagemBase64: imgBase64,
    } : null,
    criterios: criterions.filter((item: Criterios) => item.check)
      .map((item: Criterios) => item.idCriterio),
    locais: places.filter((item) => item.check).map((item) => item.idLocal),
    vantagens,
    tipoPolePosition,
  });
}

async function updatePolepostionToAnticipation(
  name: string,
  fileName: string,
  descricaoBeneficio: string,
  imgBase64: string,
  criterions: Array<Criterios>,
  places: Array<GenericPlace>,
  vantagens: Array<{
    to: string;
    from: string;
    end: string;
  }>,
  tipoPolePosition: number,
  minutosAntecipacaoAgendamento: number,
  quantidadeCorretoresBeneficiados: number,
  id: string,
) {
  await axios.put(`admin/pole-position/v1/${id}`, {
    nome: name,
    descricaoBeneficio,
    imagem: fileName ? {
      nomeImagem: fileName,
      imagemBase64: imgBase64,
    } : null,
    criterios: criterions.filter((item: Criterios) => item.check)
      .map((item: Criterios) => item.idCriterio),
    locais: places.filter((item) => item.check).map((item) => item.idLocal),
    vantagens,
    tipoPolePosition,
    minutosAntecipacaoAgendamento,
    quantidadeCorretoresBeneficiados,
  });
}
async function updatePolepostionBloqued(
  name: string,
  fileName: string,
  descricaoBeneficio: string,
  imgBase64: string,
  criterions: Array<Criterios>,
  places: Array<GenericPlace>,
  vantagens: Array<{
    to: string;
    from: string;
    end: string;
  }>,
  tipoPolePosition: number,
  quantidadeCorretoresBeneficiados: number,
  id: string,
) {
  await axios.put(`admin/pole-position/v1/${id}`, {
    nome: name,
    descricaoBeneficio,
    imagem: fileName ? {
      nomeImagem: fileName,
      imagemBase64: imgBase64,
    } : null,
    criterios: criterions.filter((item: Criterios) => item.check)
      .map((item: Criterios) => item.idCriterio),
    locais: places.filter((item) => item.check).map((item) => item.idLocal),
    vantagens,
    tipoPolePosition,
    quantidadeCorretoresBeneficiados,
  });
}
const updateStatusPole = async (id: string, status: boolean) => {
  if (status) {
    axios.put(`admin/pole-position/v1/desativar/${id}`);
  } else {
    axios.put(`admin/pole-position/v1/ativar/${id}`);
  }
};
export default {
  GetPolepositionTypes,
  SavePolepostion,
  SavePolepostionToAnticipation,
  SavePolepostionBloqued,
  GetPolepositionById,
  updatePolepostionBloqued,
  updatePolepostionToAnticipation,
  updatePolepostion,
  updateStatusPole,
};
